export const countryCodeOptions = [
    { id: '+93', value: '🇦🇫 +93', length: 9, currency: 'AFN', country: 'Afghanistan' },
    { id: '+355', value: '🇦🇱 +355', length: 9, currency: 'ALL', country: 'Albania' },
    { id: '+213', value: '🇩🇿 +213', length: 9, currency: 'DZD', country: 'Algeria' },
    { id: '+61', value: '🇦🇺 +61', length: 9, currency: 'AUD', country: 'Australia' },
    { id: '+43', value: '🇦🇹 +43', length: 10, currency: 'EUR', country: 'Austria' },
    { id: '+880', value: '🇧🇩 +880', length: 10, currency: 'BDT', country: 'Bangladesh' },
    { id: '+32', value: '🇧🇪 +32', length: 9, currency: 'EUR', country: 'Belgium' },
    { id: '+55', value: '🇧🇷 +55', length: 11, currency: 'BRL', country: 'Brazil' },
    { id: '+1', value: '🇨🇦 +1', length: 10, currency: 'CAD', country: 'Canada' },
    { id: '+86', value: '🇨🇳 +86', length: 11, currency: 'CNY', country: 'China' },
    { id: '+45', value: '🇩🇰 +45', length: 8, currency: 'DKK', country: 'Denmark' },
    { id: '+20', value: '🇪🇬 +20', length: 10, currency: 'EGP', country: 'Egypt' },
    { id: '+33', value: '🇫🇷 +33', length: 9, currency: 'EUR', country: 'France' },
    { id: '+49', value: '🇩🇪 +49', length: 10, currency: 'EUR', country: 'Germany' },
    { id: '+30', value: '🇬🇷 +30', length: 10, currency: 'EUR', country: 'Greece' },
    { id: '+852', value: '🇭🇰 +852', length: 8, currency: 'HKD', country: 'Hong Kong' },
    { id: '+91', value: '🇮🇳 +91', length: 10, currency: 'INR', country: 'India' },
    { id: '+62', value: '🇮🇩 +62', length: 10, currency: 'IDR', country: 'Indonesia' },
    { id: '+98', value: '🇮🇷 +98', length: 10, currency: 'IRR', country: 'Iran' },
    { id: '+964', value: '🇮🇶 +964', length: 10, currency: 'IQD', country: 'Iraq' },
    { id: '+353', value: '🇮🇪 +353', length: 9, currency: 'EUR', country: 'Ireland' },
    { id: '+972', value: '🇮🇱 +972', length: 9, currency: 'ILS', country: 'Israel' },
    { id: '+39', value: '🇮🇹 +39', length: 10, currency: 'EUR', country: 'Italy' },
    { id: '+81', value: '🇯🇵 +81', length: 10, currency: 'JPY', country: 'Japan' },
    { id: '+962', value: '🇯🇴 +962', length: 9, currency: 'JOD', country: 'Jordan' },
    { id: '+254', value: '🇰🇪 +254', length: 9, currency: 'KES', country: 'Kenya' },
    { id: '+965', value: '🇰🇼 +965', length: 8, currency: 'KWD', country: 'Kuwait' },
    { id: '+60', value: '🇲🇾 +60', length: 9, currency: 'MYR', country: 'Malaysia' },
    { id: '+52', value: '🇲🇽 +52', length: 10, currency: 'MXN', country: 'Mexico' },
    { id: '+977', value: '🇳🇵 +977', length: 10, currency: 'NPR', country: 'Nepal' },
    { id: '+31', value: '🇳🇱 +31', length: 9, currency: 'EUR', country: 'Netherlands' },
    { id: '+64', value: '🇳🇿 +64', length: 9, currency: 'NZD', country: 'New Zealand' },
    { id: '+234', value: '🇳🇬 +234', length: 10, currency: 'NGN', country: 'Nigeria' },
    { id: '+47', value: '🇳🇴 +47', length: 8, currency: 'NOK', country: 'Norway' },
    { id: '+92', value: '🇵🇰 +92', length: 10, currency: 'PKR', country: 'Pakistan' },
    { id: '+63', value: '🇵🇭 +63', length: 10, currency: 'PHP', country: 'Philippines' },
    { id: '+48', value: '🇵🇱 +48', length: 9, currency: 'PLN', country: 'Poland' },
    { id: '+351', value: '🇵🇹 +351', length: 9, currency: 'EUR', country: 'Portugal' },
    { id: '+974', value: '🇶🇦 +974', length: 8, currency: 'QAR', country: 'Qatar' },
    { id: '+7', value: '🇷🇺 +7', length: 10, currency: 'RUB', country: 'Russia' },
    { id: '+966', value: '🇸🇦 +966', length: 9, currency: 'SAR', country: 'Saudi Arabia' },
    { id: '+65', value: '🇸🇬 +65', length: 8, currency: 'SGD', country: 'Singapore' },
    { id: '+27', value: '🇿🇦 +27', length: 9, currency: 'ZAR', country: 'South Africa' },
    { id: '+34', value: '🇪🇸 +34', length: 9, currency: 'EUR', country: 'Spain' },
    { id: '+94', value: '🇱🇰 +94', length: 9, currency: 'LKR', country: 'Sri Lanka' },
    { id: '+46', value: '🇸🇪 +46', length: 9, currency: 'SEK', country: 'Sweden' },
    { id: '+41', value: '🇨🇭 +41', length: 9, currency: 'CHF', country: 'Switzerland' },
    { id: '+66', value: '🇹🇭 +66', length: 9, currency: 'THB', country: 'Thailand' },
    { id: '+90', value: '🇹🇷 +90', length: 10, currency: 'TRY', country: 'Turkey' },
    { id: '+971', value: '🇦🇪 +971', length: 9, currency: 'AED', country: 'UAE' },
    { id: '+44', value: '🇬🇧 +44', length: 10, currency: 'GBP', country: 'UK' },
    { id: '+1', value: '🇺🇸 +1', length: 10, currency: 'USD', country: 'USA' },
    { id: '+84', value: '🇻🇳 +84', length: 9, currency: 'VND', country: 'Vietnam' },
];

// ISO 3166-1 alpha-2 codes, keyed by the same `country` names used above.
// Needed for Square's paymentRequest.countryCode (Apple Pay / Google Pay), which
// is NOT the same as the phone dialing code (`id`) stored in countryCodeOptions.
const isoCountryCodeMap = {
    'Afghanistan': 'AF',
    'Albania': 'AL',
    'Algeria': 'DZ',
    'Australia': 'AU',
    'Austria': 'AT',
    'Bangladesh': 'BD',
    'Belgium': 'BE',
    'Brazil': 'BR',
    'Canada': 'CA',
    'China': 'CN',
    'Denmark': 'DK',
    'Egypt': 'EG',
    'France': 'FR',
    'Germany': 'DE',
    'Greece': 'GR',
    'Hong Kong': 'HK',
    'India': 'IN',
    'Indonesia': 'ID',
    'Iran': 'IR',
    'Iraq': 'IQ',
    'Ireland': 'IE',
    'Israel': 'IL',
    'Italy': 'IT',
    'Japan': 'JP',
    'Jordan': 'JO',
    'Kenya': 'KE',
    'Kuwait': 'KW',
    'Malaysia': 'MY',
    'Mexico': 'MX',
    'Nepal': 'NP',
    'Netherlands': 'NL',
    'New Zealand': 'NZ',
    'Nigeria': 'NG',
    'Norway': 'NO',
    'Pakistan': 'PK',
    'Philippines': 'PH',
    'Poland': 'PL',
    'Portugal': 'PT',
    'Qatar': 'QA',
    'Russia': 'RU',
    'Saudi Arabia': 'SA',
    'Singapore': 'SG',
    'South Africa': 'ZA',
    'Spain': 'ES',
    'Sri Lanka': 'LK',
    'Sweden': 'SE',
    'Switzerland': 'CH',
    'Thailand': 'TH',
    'Turkey': 'TR',
    'UAE': 'AE',
    'UK': 'GB',
    'USA': 'US',
    'Vietnam': 'VN',
};

export const getIsoCountryCode = (countryName, fallback = 'US') => {
    if (!countryName) return fallback;
    return isoCountryCodeMap[countryName.trim()] || fallback;
};